import React from 'react';
import InstagramIcon from '../../icons/Instagram';
import FacebookIcon from '../../icons/Facebook';
import LinkedInIcon from '../../icons/LinkedIn';
import TwitterIcon from '../../icons/Twitter';
import * as S from './SocialIcons.styles';

type SocialIconsProps = {
  facebook?: string;
  instagram?: string;
  linkedIn?: string;
  twitter?: string;
};

const SocialIcons = ({ facebook, instagram, linkedIn, twitter }: SocialIconsProps) => (
  <S.Icons>
    {facebook && (
      <S.IconWrapper href={facebook} aria-label="NAF på Facebook" target="_blank">
        <FacebookIcon />
      </S.IconWrapper>
    )}
    {instagram && (
      <S.IconWrapper href={instagram} aria-label="NAF på Instagram" target="_blank">
        <InstagramIcon />
      </S.IconWrapper>
    )}
    {linkedIn && (
      <S.IconWrapper href={linkedIn} aria-label="NAF på LinkedIn" target="_blank">
        <LinkedInIcon />
      </S.IconWrapper>
    )}
    {twitter && (
      <S.IconWrapper href={twitter} aria-label="NAF på Twitter" target="_blank">
        <S.SizedIcon>
          <TwitterIcon />
        </S.SizedIcon>
      </S.IconWrapper>
    )}
  </S.Icons>
);

export default SocialIcons;
